// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RTkTw","content":"styles_content__cNcva","row":"styles_row__1QVqZ","footer":"styles_footer__sZVWy","phraseLength":"styles_phraseLength__3VRlK"};